const ALPHABET = "_-0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
const LENGTH = 9;

export function generateElementId() {
  const bytes = new Uint8Array(LENGTH);
  crypto.getRandomValues(bytes);
  let out = "";
  for (let i = 0; i < LENGTH; i++) {
    out += ALPHABET[bytes[i] % ALPHABET.length];
  }
  return out;
}

export const ELEMENT_ID_ATTRIBUTE = "tiptap-element-id";
export const ELEMENT_ID_TYPES = [
  "paragraph",
  "heading",
  "listItem",
  "orderedList",
  "bulletList",
  "blockquote",
  "codeBlock",
  "tableCell",
  "tableHeader",
  "tableRow",
  "table",
  "horizontalRule",
  "hardBreak",
  "vimeo",
];
